import React, { useEffect, useState } from 'react';
import AdminShell from '../components/AdminShell';
import { api } from '../lib/api';
import { Info } from 'lucide-react';

const AdminAdmins = () => {
  const [rows, setRows] = useState([]);

  useEffect(() => {
    api.get('/admin/admins').then((r) => setRows(r.data.items || []));
  }, []);

  return (
    <AdminShell title="Administrative users">
      <div className="bg-[#FFF9E6] border border-[#D4A017]/30 text-[#1B2A41] rounded-2xl p-4 mb-5 flex gap-3" data-testid="admins-info">
        <Info size={18} className="text-[#D4A017] shrink-0 mt-0.5"/>
        <div className="text-sm">
          <p className="font-semibold mb-1">Access is controlled by the Google email allowlist.</p>
          <p className="text-[#4B5563]">
            To grant another person admin access, add their Google email to the <code className="font-mono text-xs bg-white border border-black/5 px-1.5 py-0.5 rounded">OWNER_EMAILS</code> secret
            and redeploy. They sign in at <code className="font-mono text-xs bg-white border border-black/5 px-1.5 py-0.5 rounded">/admin/login</code> with
            that same Google account. To revoke, remove the email from <code className="font-mono text-xs bg-white border border-black/5 px-1.5 py-0.5 rounded">OWNER_EMAILS</code> — any
            active session for that account is invalidated on the next request.
          </p>
        </div>
      </div>

      <div className="bg-white rounded-2xl border border-black/5 overflow-x-auto" data-testid="admins-table">
        <table className="w-full text-sm">
          <thead className="bg-[#F3F5F2] text-left"><tr>
            <th className="px-4 py-3 font-semibold">Name</th>
            <th className="px-4 py-3 font-semibold">Email</th>
            <th className="px-4 py-3 font-semibold">Role</th>
            <th className="px-4 py-3 font-semibold">Status</th>
          </tr></thead>
          <tbody>
            {rows.map((u) => (
              <tr key={u.id} className="border-t border-black/5" data-testid={`admin-row-${u.id}`}>
                <td className="px-4 py-3">{u.name}</td>
                <td className="px-4 py-3">{u.email}</td>
                <td className="px-4 py-3"><span className="text-xs font-mono tracking-wider">{u.role}</span></td>
                <td className="px-4 py-3"><span className="text-xs font-semibold px-2 py-1 rounded-full bg-[#F3F5F2]">{u.status}</span></td>
              </tr>
            ))}
            {!rows.length && <tr><td colSpan={4} className="px-4 py-8 text-center text-[#4B5563]">No administrators configured.</td></tr>}
          </tbody>
        </table>
      </div>
    </AdminShell>
  );
};

export default AdminAdmins;
